/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

function getQueryParameter(name) {
    var result = false;
    var regexp = new RegExp(name + '=(.*?)(&|$)');
    var urlParameter = location.search.match(regexp);
    if (urlParameter !== null && urlParameter.length > 2) result = urlParameter[1];
    return result;
}

(function () {
    if(location.href.indexOf('/account/login') !== -1) {
        var redirect = getQueryParameter('redirect');
        if(redirect) Cookies.set('redirect', redirect);
    } else {
        var url = Cookies.get('redirect');
        if(url) {
            Cookies.remove('redirect');
            location.href = url;
        }
    }
})();